import BaseWebSocketSubscriber from './base.websocket.subscriber'

const MESSAGE_TYPES = {
  CERTIFICATES_SENT: 'certificates-sent',
}

class CertificateWebSocketSubscriber extends BaseWebSocketSubscriber {
  init() {
    this.socketClient.on(MESSAGE_TYPES.CERTIFICATES_SENT, this.onCertificatesSent.bind(this))
  }

  onCertificatesSent(data) {
    if (!this.$store.getters['liveCertificate/isLiveCertificateOn']) return
    if (!data?.certificate?.verifyUrl) return
    this.$store.commit('liveCertificate/showCertificate', data.certificate)
  }
}

export default CertificateWebSocketSubscriber
